import { Component, Input, ViewChild } from '@angular/core';
import { Cabecalho } from 'src/app/models/cabecalho.model';
import { Dataset } from 'src/app/models/dataset.model';
import { Template } from 'src/app/models/template.model';
import { RequestsService } from '../../services/requests.service';
import { SanitizeHtmlPipe } from '../../pipes/sanitize.pipe';
import { AddCabecalhoComponent } from '../add-cabecalho/add-cabecalho.component';


@Component({
  selector: 'side-menu-live-view',
  styleUrls: ['./side-menu-live-view.component.scss'],
  templateUrl: `./side-menu-live-view.component.html`
})
export class SideMenuLiveViewComponent {
  public data: string;
  public isCabecalho: boolean
  public datasets: Dataset[] = [];
  public cabecalhos: Cabecalho[] = [];
  public template: Template;
  public cabecalhoSelecionado: Cabecalho;
  public isCollapsed = false;
  @ViewChild('modalCabecalho', { static: true }) private modalCabecalho: AddCabecalhoComponent;

  constructor(private requestService: RequestsService) {

  }

  public iniciar(obj, _isCabecalho: boolean) {
    this.isCabecalho = _isCabecalho;
    this.template = obj;

    if (this.template) {
      this.carregarDatasets();
      this.carregarCabecalhos();
    }
  }

  private carregarDatasets() {
    this.requestService.listDatasetsByProjeto(this.template.idProjeto).subscribe(x => {
      this.datasets = x;
    });

  }
  private carregarCabecalhos() {
    this.requestService.listCabecalhosByProjeto(this.template.idProjeto).subscribe(x => {
      this.cabecalhos = x;
      this.cabecalhoSelecionado = this.cabecalhos.find(c => c.idCabecalho == this.template.idCabecalho);
    });
  }

  public onChangeCabecalho(event) {
    this.cabecalhoSelecionado = this.cabecalhos.find(c => c.idCabecalho == event.args.value);
  }

  editarCabecalho(registro) {


    this.modalCabecalho.abrir(registro, registro.idProjeto).then(x => {
      this.carregarCabecalhos();
    });
  }


}
